import { ChangeEvent, useState } from "react";
import { Stack, TextField } from "@mui/material";
import BMIGauge from ".";

export default function BMIGaugeExamples() {
  const [value, setValue] = useState(25);
  return (
    <Stack>
      <BMIGauge value={value} />
      <TextField
        sx={{ mt: 1 }}
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          setValue(+event.target.value)
        }
        value={value}
        fullWidth
      />
    </Stack>
  );
}
